<template>
  <div v-for="textField in textFields" :key="textField">
    <Textfield
      :type="this.type"
      :textFieldId="textField.id"
      :textId="textField.textId"
      :imageId="textField.imageId"
      :imagePlacement="textField.imagePlacement"
      :timestamp="textField.timestamp"
    />
  </div>
  <div v-if="isAdmin" class="buttonWrapper">
    <button @click="popup()">
      <p v-if="!showAddParagraph">Lägg till paragraf</p>
      <p v-if="showAddParagraph">Dölj meny</p>
    </button>
  </div>
  <div v-if="showAddParagraph" class="buttonWrapper addSectionMenu">
    <button @click="addParagraph('left')">Vänster</button>
    <button @click="addParagraph('top')">Toppen</button>
    <button @click="addParagraph('right')">Höger</button>
  </div>
</template>

<script>
import Textfield from "@/Components/Textfield.vue";
import { getTextFields, addTextField, addText } from "@/firebase";
import Cookies from "js-cookie";

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      textFields: [],
      showAddParagraph: false,
      isAdmin: Cookies.get("user") ? true : false,
    };
  },
  async mounted() {
    this.textFields = await getTextFields(this.type);
  },
  components: {
    Textfield,
  },
  methods: {
    popup() {
      this.showAddParagraph = !this.showAddParagraph;
      console.log(Cookies.get("user"));
    },
    async addParagraph(alignment) {
      if (alignment) {
        const textId = await addText({ text: "Skriv text här! 😊" });
        const data = {
          timestamp: Date.now(),
          imageId: "garden.jpg",
          imagePlacement: alignment,
          textId: textId.id,
        };
        const newTextField = await addTextField(this.type, data);
        this.textFields = await getTextFields(this.type);
        this.$notify({
          text: "Paragraf tillagd",
          type: "success",
        });
      } else {
        throw "Invalid alignment";
      }
    },
    async deletedTextField(removedTextFieldId) {
      this.textFields = await getTextFields(this.type);
      this.$notify({
        text: "Paragraf borttagen",
        type: "success",
      });
    },
  },
};
</script>

<style scoped>
.addSectionMenu {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
.buttonWrapper p {
  margin: 0px;
}
.addSectionMenu button {
  margin: 1vw;
}
</style>
